const Register = require('./register');
const Sound = require('./sound');

class Game {
  constructor(Data,isMobile) {

    // データ取得クラス初期化
    const register = new Register();
    const sound = new Sound();

    // ステージ作成
    var canvas = $('#canvas').get(0);
    var height = $(window).height();
    var width = $(window).width();
    canvas.width = width * window.devicePixelRatio;
    canvas.height = height * window.devicePixelRatio;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';

    var stage = new createjs.Stage('canvas');
/*
    stage.scaleX = window.devicePixelRatio;
    stage.scaleY = window.devicePixelRatio;
*/


    // タッチをサポートしているブラウザ判定
    if (createjs.Touch.isSupported()) {
      createjs.Touch.enable(stage);
    }
    //画像クラスを呼ぶ
    var dataClass = Data;
    var items = [];

    var dog;//犬のshape
    var backMoveSpeed = 1;
    var dogMoveSpeed = 8;
    var ready;
    var retry;
    var velocity = 0; // 糸の上昇or下降の速さ
    var property = {
      'FPS'     : 60,  // 画面更新の速さ
      'GRAVITY' :2000,  // 重力加速度
      'BOOST' :1000,  // 加速
    };
    var imageCm = 0;//画面の幅に合わせた画像の比率
    var dogSize = 100;
    var blockSize = 100;

    var isPlay = false;
    var isRaise = false;
    var point = 0;
    var highScore = 0;
    var pointText;
    var highScoreText;
    var gameOverText;
    var highScoreAlertText;
    var gameContainer;
    var backBits = [];
    var blocks = [];
    var dogBit = {
      on:null,
      off:null
    }
    var blockProperty = {
      nowHeight:0,
      maxHeight:0,
      maxWidth:200,
      signValue:1,
      maxCut:0,
      maxPutX:0,
      margin:6,
      level:0,
      color:"#FFE26F"
    }
    var devicePixelRatio = window.devicePixelRatio;
    if(isMobile){
      devicePixelRatio = 0.5 * window.devicePixelRatio;
    }
    // *****************************
    // 画像読み込み完了時に呼ぶ
    // *****************************
    function init(){
      clearCanvas();
      stopTick();
      // ==========================
      // オープニング
      // ==========================
      $('#splash').fadeIn(function(){
        // スプラッシュ消える
        $('#splash').delay(800).fadeOut(function(){
          // top表示
          $('#wrap').fadeIn(showOpning());
        });
      });
    }
    dataClass.imagePreLoad(init());
    function initGame(){
      isPlay = false;
      isRaise = false;
      //速さを初期化
      velocity = 0;
      point = 0;
      blockProperty.level = 0;
      stopTick();
    }
    function showPointText(){
      pointText.text = "SCORE: " + point;
    }
    function showHighScoreText() {
      highScoreText.text = "HIGH SCORE: " + highScore;
    }
    function showOpning(){
      register.getHighScore((data) => {
        //犬とブロック用コンテナ
        gameContainer = new createjs.Container();
        stage.addChild(gameContainer);

        // ハイスコア取得
        highScore = data.highScore;

        initGame();
        dog = getDog();
        setBack();
        var startPoint = {x:dog.width/2,y:canvas.height /2};
        dog.x= startPoint.x;
        dog.y = startPoint.y

        // ステージに追加
        gameContainer.addChild(dog);


        // スタートボタン
        const btnW = 320;
        const btnH = 160;
        ready = new createjs.Container();
        ready.x = canvas.width / 2 - btnW / 2;
        ready.y = canvas.height / 2 - btnH / 2;
        stage.addChild(ready);
        const bg = new createjs.Shape();
        bg.graphics
          .setStrokeStyle(6)
          .beginStroke('#5555555')
          .beginFill('#ffdddd')
          .drawRoundRect(0, 0, btnW, btnH, 16);
        ready.addChild(bg);
        var label = new createjs.Text('READY', '80px Noto Sans Japanese', '#555555');
        label.x = btnW / 2;
        label.y = btnH / 2;
        label.textAlign = 'center';
        label.textBaseline = 'middle';
        ready.addChild(label);

        // ハイスコア
        highScoreText = createText(highScore, 'left');
        highScoreText.x = 30;
        highScoreText.y = 0;
        showHighScoreText();
        stage.addChild(highScoreText);

        // スコア
        pointText = createText(point,'left');
        pointText.x = 30;
        pointText.y = 80;
        showPointText();
        stage.addChild(pointText);

        // クリックでゲーム開始
        canvas.addEventListener(convertMouseEvent('click'), startGame, false);
        startTick();
      });
    }
    function startTick(){
      // メインループ
      createjs.Ticker.addEventListener('tick', function(){
        // 更新
        moveBack();
        if(isPlay){
          moveDog();
          moveBlock();
          calcPoint();
          showPointText();
        }
        stage.update();
      });
//      createjs.Ticker.timingMode = createjs.Ticker.RAF;
      createjs.Ticker.timingMode = createjs.Ticker.TIMEOUT;
      createjs.Ticker.setFPS(property.FPS);
    }
    function clearGameObject(){
      gameContainer.removeChild(dog);
      stage.removeChild(pointText);
      stage.removeChild(highScoreText);
      for(var block of blocks){
        gameContainer.removeChild(block.top);
        gameContainer.removeChild(block.bottom);
      }
      blocks = [];
    }
    function createText(str,align){
      var text = new createjs.Text(str, '64px Noto Sans Japanese', '#333333');
      if(align){
        text.textAlign = align;
      }
      return text;
    }
    function moveDog(){
      if(isRaise){
        velocity =- property.BOOST;
        isRaise = false;
      }else{
        velocity += property.GRAVITY * 1/ property.FPS;
      }
      if(velocity < 0){
        if(dog.boost === false){
          setDogBoostImage(true);
        }
      }else{
        if(dog.boost === true){
          setDogBoostImage(false);
        }
      }
      // Bitmapオブジェクトを90度回転
      dog.y = velocity * (1/property.FPS) + dog.y;

      //犬の回転
      // var rad = Math.atan2(velocity - dog.y,property.BOOST - dog.x);
      // var x = dog.getBounds().width / 2;
      // var y = dog.getBounds().height / 2;
      // dog.regX = x;
      // dog.regY = y;
      // dog.rotation = (rad * 180 / Math.PI)+50;
      if (dog.y + dog.height >= canvas.height) {
        velocity = property.BOOST*1.2;
        velocity =- (velocity);
      }
      if (dog.y < 0) {
        velocity = property.BOOST*1.2;
        velocity = (velocity);
      }
    }
    function isHit(block){
      //上のブロックと犬のあたり
      var hit = false;
      var margin = 0;
      if((dog.x + dog.width) > block.top.x &&  (dog.x + dog.width) < block.top.x + block.top.width){
        if(dog.y < block.top.height){
          hit =true;
        }
      }
      if((dog.x + dog.width) > block.bottom.x && (dog.x + dog.width) < block.bottom.x + block.bottom.width){
        if((dog.y+dog.height) > block.bottom.y){
          hit =true;
        }
      }
      return hit;
    }

    function moveBlock(){
      var length = blocks.length;
      for(var i=0;i < length;i++){
        blocks[i].top.x -= dogMoveSpeed * devicePixelRatio;
        blocks[i].bottom.x -= dogMoveSpeed * devicePixelRatio;
        if(blocks[i].top.x <= canvas.width && blocks[i].top.isShow === false){
           gameContainer.addChild(blocks[i].top);
           gameContainer.addChild(blocks[i].bottom);
           blocks[i].top.isShow = true;
           blocks[i].bottom.isShow = true;
        }

        if((blocks[i].top.x + (blockProperty.maxWidth)) <= 0 && blocks[i].top.isShow === true){
          gameContainer.removeChild( blocks[i].top);
          gameContainer.removeChild( blocks[i].bottom);
          blocks[i].top.isShow = false;
          blocks[i].bottom.isShow = false;
          changeBlock(blocks[i],i);
        }
        if(isHit(blocks[i]) && isPlay){
          isPlay = false;
          gameOver();
          break;
        }
      }
    }
    // 開始処理
    function startGame(){
      sound.playButton();
      createBlock();
      isPlay = true;
      stage.removeChild(ready);
      canvas.removeEventListener(convertMouseEvent('click'), startGame, false);
      canvas.addEventListener(convertMouseEvent('click'), chageRaise, false);
    }
    function gameOver(){
      gameContainer.removeChild(dog);
      canvas.removeEventListener(convertMouseEvent('click'), chageRaise, false);
      updateHighScore(function(isHighScore) {
        // ゲームオーバー
        gameOverText = new createjs.Text('GAMEOVER', '80px Noto Sans Japanese', '#333333');
        gameOverText.textAlign = "center";
        gameOverText.x = canvas.width/2;
        gameOverText.y = (canvas.height/2 - 100);
        gameOverText.text = "GAME OVER";
        // ハイスコア
        highScoreAlertText = createText(highScore, 'center');
        highScoreAlertText.x = canvas.width/2;
        highScoreAlertText.y = (canvas.height/2) + 50;
        if (isHighScore) {
          highScoreAlertText.text = 'HIGH SCORE!';
          highScore = point;
          showHighScoreText();
        } else {
          highScoreAlertText.text = '';
        }
        stage.addChild(gameOverText);
        stage.addChild(highScoreAlertText);
        canvas.addEventListener(convertMouseEvent('click'), resetGame, false);
      });
    }
    function resetGame() {
      stage.removeChild(gameContainer);
      stage.removeChild(gameOverText);
      stage.removeChild(highScoreAlertText);
      canvas.removeEventListener(convertMouseEvent('click'), resetGame, false);
      clearGameObject();
      showOpning();
    }
    // ハイスコア更新チェックと更新処理
    function updateHighScore(cb) {

      // ハイスコア取得
      register.getHighScore((data) => {
        if (point > data.highScore) {
          // ハイスコア更新
          register.setHighScore(point, (result) => {
            console.log(result);
            cb(true);
          });
        } else {
          cb(false);
        }
      });

    }
    function chageRaise() {
      sound.playFly();
      if(isRaise){
        isRaise = false;
      }else{
        isRaise = true;
      }
    };

    /*****************************************************************
   *  convertMouseEvent
   *  イベントをPCとスマホで切り替える
   *  @param {string} eventStr {イベント名}
   **********************************************************************/
  function convertMouseEvent(eventStr) {
    let event;
    switch (eventStr) {
      case 'mousedown': //off
        event = (window.ontouchstart === undefined)
            ? 'mousedown'
            : 'touchstart';
        break;
      case 'mousemove': //on
        event = (window.ontouchmove === undefined) ? 'mousemove' : 'touchmove';
        break;
      case 'mouseup': //通信不能
        event = (window.ontouchend === undefined) ? 'mouseup' : 'touchend';
        break;
      case 'mouseleave': //通信不能
        event = (window.ontouchcancel === undefined)
            ? 'mouseleave'
            : 'touchcancel';
        break;
      case 'click': //通信不能
        event = (window.ontouchstart === undefined) ? 'click' : 'touchstart';
        break;
    }
    return event;
  }
    //ゲームの描画の終了
    function endGame(){
      stopTick();
      createjs.Sound.stop();
      clearEvent();
      stage.update();
    }
    function clearCanvas(){
      stage.removeAllChildren();
      stage.update();
    }
    function stopTick(){
      createjs.Ticker.removeAllEventListeners('tick');
    }

    function getDog() {
      dogBit.on =  new createjs.Bitmap(dataClass.getImageAsset('dog_on'));
      dogBit.off =  new createjs.Bitmap(dataClass.getImageAsset('dog_off'));
      var bitmap  =new createjs.Bitmap();
      bitmap.image = dogBit.off.image;
      // サイズを設定
      bitmap.scaleX = devicePixelRatio;
      bitmap.scaleY = devicePixelRatio;
      bitmap.x = 0;
      bitmap.y = 0;
      bitmap.width = bitmap.getBounds().width * devicePixelRatio;
      bitmap.height = bitmap.getBounds().height * devicePixelRatio;
      bitmap.boost = false;
      // 変数にkushiのオブジェクトを保存
       return bitmap;
    }
    function setDogBoostImage(isOn) {
      if(isOn){
        dog.image = dogBit.on.image;
        dog.boost = true;
      }else{
        dog.image = dogBit.off.image;
        dog.boost = false;
      }
    }
    function setBack() {
      if(backBits.length === 0){
        var bitmap1 = getBack();
        var bitmap2 = getBack();
        bitmap2.x = bitmap1.width;
        backBits[backBits.length] = bitmap1;
        backBits[backBits.length] = bitmap2;
      }
    }
    function getBack(){
      var bitmap = new createjs.Bitmap(dataClass.getImageAsset('back'));
      // サイズを設定
      var scale = canvas.height / (bitmap.getBounds().height);
      bitmap.scaleX = scale;
      bitmap.scaleY = scale;
      bitmap.x = 0;
      bitmap.y = 0;
      bitmap.width = (bitmap.getBounds().width * scale) - 50;//微調整
      bitmap.height = bitmap.getBounds().height * scale;
      bitmap.isShow = false;
      return bitmap;
    }
    function createBlock(){
      chageLevel();
      var blockCount = (canvas.width*blockProperty.margin) / (blockProperty.maxWidth * blockProperty.margin);
      var putX = canvas.width;
      var putY = 0;
      var cut = blockProperty.maxCut;
      var id =1;
      for(var i=0; i < blockCount;i++){
        var block = {top:null,bottom:null};
        blockProperty.nowHeight = blockProperty.maxHeight - ((dog.height*1) * cut);
        cut -= 2;
        if(cut <= 3){
          cut = 3;
        }
        var topRatio = 2;
        var topHight = blockProperty.nowHeight / topRatio;
        var bottomHight = blockProperty.nowHeight - topHight;
        block.top = getBlockShape(blockProperty.maxWidth,topHight,putX,0,blockProperty.color,id);
        var bottomY = canvas.height - (topHight);
        block.bottom = getBlockShape(blockProperty.maxWidth,bottomHight,putX,bottomY,blockProperty.color,id);
        blockProperty.maxPutX = putX;
        putX += blockProperty.maxWidth * blockProperty.margin;
        blocks[blocks.length] = block;
        id++;
      }
    }
    //レベルに応じた変化
    function levelCheck(){
      var topRatio = calcRandom(20,85);
      if(blockProperty.level > 10){
        topRatio = calcRandom(20,85);
      }else if(blockProperty.level > 10){
        topRatio = calcRandom(15,90);
      }else if(blockProperty.level > 20){
        topRatio = calcRandom(10,95);
      }else if(blockProperty.level > 30){
        topRatio = calcRandom(1,100);
      }

      return topRatio;

    }
    function changeBlock(block,index){
      chageLevel();
      var putX = blockProperty.maxPutX;
      var putY = 0;
      //犬の何個分最大高さからカットするか
      //高さの縦の割合
      var topRatio = levelCheck();
//      blockProperty.nowHeight = (blockProperty.maxHeight) - (dog.height * levelCheck());
      blockProperty.nowHeight = (blockProperty.maxHeight) - (dog.height * 2.5);
      var topHight = blockProperty.nowHeight * (topRatio / 100);
      var bottomHight = blockProperty.nowHeight - topHight;
      block.top = getBlockShape(blockProperty.maxWidth,topHight,putX,0,blockProperty.color,block.top.id);
      var bottomY = canvas.height - bottomHight;
      block.bottom = getBlockShape(blockProperty.maxWidth,bottomHight,putX,bottomY,blockProperty.color,block.bottom.id);
      blocks[index] = block;
    }
    function chageLevel(){
        blockProperty.level +=1;
        blockProperty.maxHeight = canvas.height;
        blockProperty.maxCut = Math.floor(blockProperty.maxHeight/dog.height);
    }
    function getBlockShape(width,height,x,y,color,id){
      var shape = new createjs.Shape();
      shape.graphics.beginFill(color); // 赤色で描画するように設定
      shape.graphics.drawRoundRect(0, 0, width,height, 0, 0); //100pxの正方形を描画。20pxの角丸を設定。
      shape.isShow = false;
      shape.width = width;
      shape.height = height;
      shape.id =id;
      shape.x = x;
      shape.y = y;
      return shape;
    }
    function calcRandom(min,max){
      var value = Math.floor( Math.random() * (max + 1 - min) ) + min ;
      return value;
    }

    function moveBack(){
      for(var back of backBits){
        if(back.x <= canvas.width && back.isShow === false){
          back.isShow = true;
          stage.addChild(back);
          stage.setChildIndex(back,0);//最背面
        }
        if(back.x <= -(back.width) && back.isShow === true){
          back.isShow = false;
          stage.removeChild(back);
          back.x = back.width;
        }
        back.x -= backMoveSpeed;
      }
    }
    // 点数計算
    function calcPoint(){
      point++;
    }

    // メッセージ
    (function(){
      var headStyle = 'color:#c2382c; font-size:20px; font-weight: bold; font-family: Helvetica';
      var copyStyle = 'color:#c2382c; font-size:10px; font-family: Helvetica';
      console.log('%cHappy New Year 2018!!' , headStyle);
      console.log('%ccreated by SRIA Inc. 2018' , copyStyle);
    })();
  }
}

module.exports = Game;



// WEBPACK FOOTER //
// ./app/src/js/modules/game.js